var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M13 7.15V9.1c0 1.434-1.166 2.6-2.6 2.6H2.6A2.603 2.603 0 0 1 0 9.1V7.15a.65.65 0 1 1 1.3 0V9.1c0 .717.583 1.3 1.3 1.3h7.8c.717 0 1.3-.583 1.3-1.3V7.15a.65.65 0 1 1 1.3 0ZM6.04 8.639a.648.648 0 0 0 .92 0l1.95-1.95a.65.65 0 1 0-.92-.92l-.84.84V.65a.65.65 0 1 0-1.3 0v5.96l-.84-.84a.65.65 0 1 0-.92.919l1.95 1.95Z"}));
}

Download.defaultProps = {"fill":"none","viewBox":"0 0 13 12"};

module.exports = Download;

Download.default = Download;
